import { render, staticRenderFns } from "./NoVipPopover.vue?vue&type=template&id=23c98a8e&scoped=true"
import script from "./NoVipPopover.vue?vue&type=script&lang=ts"
export * from "./NoVipPopover.vue?vue&type=script&lang=ts"
import style0 from "./NoVipPopover.vue?vue&type=style&index=0&id=23c98a8e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c98a8e",
  null
  
)

/* custom blocks */
import block0 from "./NoVipPopover.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports